export default function extractNewsData(data) {
  return {
    link: data?.link,
    summary: data?.summary,
    title: data?.title,
    subtitle: data?.sub_title,
    content: data?.content,
    reporters: data?.reporters,
    image: { _renditions: { '1280x720': data?.thumbnail } },
    type: 'news',
    id: data?.id,
    playIcon: false,
    newWindow: true,
  }
}
